import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import moment from 'moment'
import { formatDocument } from 'utils/masks'

const WAITING_TIME_THRESHOLD = 10
const ABOVE_OPTION = 'timeAbove'
const BELLOW_OPTION = 'timeUnder'
const ALL_OPTION = 'timeAll'

class ModalReportDetails extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    closeModalDetails: PropTypes.func.isRequired,
    modalOption: PropTypes.string.isRequired,
    modalData: PropTypes.array,
    calculateWait: PropTypes.func,
    modalOrderDetail: PropTypes.bool,
    showOrderDetails: PropTypes.func.isRequired,
    hideOrderDetails: PropTypes.func.isRequired,
    salesOrderDetailInformation: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      size: 'sm',
    }
  }

  renderModalHeader = () => {
    const { translate, modalOption } = this.props

    let title
    switch (modalOption) {
      case ABOVE_OPTION:
        title = translate('totem.reports.filter.header.above')
        break
      case BELLOW_OPTION:
        title = translate('totem.reports.filter.header.under')
        break
      case ALL_OPTION:
        title = translate('totem.reports.modal.header.all')
        break
      default:
        title = moment(modalOption, 'DD/MM/YYYY').format('LL')
        break
    }

    return (
      <Row>
        <Col xs={12} className='margin-bottom-double'>
          <div className='totemreports-filter-modal-title'>{title}</div>
        </Col>
      </Row>
    )
  }

  countItems = (option) => {
    const { modalData } = this.props

    if (option === ABOVE_OPTION) {
      return modalData.filter(
        (item) => parseInt(item.waitingTime, 10) >= WAITING_TIME_THRESHOLD
      ).length
    }
    if (option === BELLOW_OPTION) {
      return modalData.filter(
        (item) => parseInt(item.waitingTime, 10) < WAITING_TIME_THRESHOLD
      ).length
    }
  }

  renderModalCards = () => {
    const { translate } = this.props
    return (
      <Row>
        <Col xs={12} md={6}>
          <div className='totemreports-header-card-small'>
            <p className='totemreports-card-description-small'>
              {translate('totem.reports.modal.card.neg.label')}
            </p>
            <p className='totemreports-card-value-small'>
              {this.countItems(BELLOW_OPTION).toString() +
                translate('totem.reports.graph.orders.label')}
            </p>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className='totemreports-header-red-card-small'>
            <p className='totemreports-card-description-small'>
              {translate('totem.reports.modal.card.pos.label')}
            </p>
            <p className='totemreports-card-value-small'>
              {this.countItems(ABOVE_OPTION).toString() +
                translate('totem.reports.graph.orders.label')}
            </p>
          </div>
        </Col>
      </Row>
    )
  }

  renderModalTable = () => {
    const { modalData, translate, calculateWait, showOrderDetails } = this.props
    return (
      <div>
        <Row className='totemreports-modal-table'>
          <Col xs={4}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.table.header.orders')}
            </div>
          </Col>
          <Col xs={4}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.table.header.wait.time')}
            </div>
          </Col>
          <Col xs={4}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.table.header.timestamp')}
            </div>
          </Col>
        </Row>
        <div className='totemreports-modal-table-scroll'>
          {modalData.map((item, i) => {
            const waitTime = calculateWait(item.waitingTime, true)
            return (
              <a
                key={i}
                role='button'
                onClick={() => showOrderDetails(item.salesOrder)}
              >
                <Row className='totemreports-modal-table-content'>
                  <Col xs={4}>
                    <div className='totemreports-modal-table-ordernumber'>
                      {item.salesOrder.header.orderNumber}
                    </div>
                  </Col>
                  <Col xs={4}>
                    <div>{waitTime}</div>
                  </Col>
                  <Col xs={4}>
                    <div>{item.refTs}</div>
                  </Col>
                </Row>
              </a>
            )
          })}
        </div>
      </div>
    )
  }

  renderSalesOrderDetails = () => {
    const { translate, salesOrderDetailInformation } = this.props

    return (
      <div>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.order.detail.order')}
            </div>
          </Col>
        </Row>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-sales-order-info'>
              {salesOrderDetailInformation.header.orderNumber}
            </div>
          </Col>
        </Row>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.order.detail.client')}
            </div>
          </Col>
        </Row>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-sales-order-info'>
              {salesOrderDetailInformation.header.customer.name}
            </div>
          </Col>
        </Row>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.order.detail.doc')}
            </div>
          </Col>
        </Row>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-sales-order-info'>
              {formatDocument(
                salesOrderDetailInformation.header.customer.document,
                translate
              )}
            </div>
          </Col>
        </Row>
        <Row className='totemreports-modal-table-order-detail'>
          <Col xs={6}>
            <div className='totemreports-modal-table-header'>
              {translate('totem.reports.modal.order.detail.table.products')}
            </div>
          </Col>
          <Col xs={6}>
            <div className='totemreports-modal-table-header-qnt'>
              {translate('totem.reports.modal.order.detail.table.qnt')}
            </div>
          </Col>
        </Row>
        <div className='totemreports-modal-table-scroll'>
          {salesOrderDetailInformation.products.map((item, i) => (
            <Row key={i} className='totemreports-modal-table-order-products'>
              <Col xs={6}>
                <div className='totemreports-modal-sales-order-info-listed'>
                  {item.name}
                </div>
              </Col>
              <Col xs={6}>
                <div className='totemreports-modal-sales-order-info-listed-qnt'>
                  {item.productQuantity}
                </div>
              </Col>
            </Row>
          ))}
        </div>
      </div>
    )
  }

  showCards = () => {
    const { modalOption } = this.props
    return (
      modalOption !== ABOVE_OPTION &&
      modalOption !== BELLOW_OPTION &&
      modalOption !== ALL_OPTION
    )
  }

  renderModalButtons = () => {
    const { translate, modalOrderDetail, closeModalDetails, hideOrderDetails } =
      this.props

    return (
      <Row className='totemreports-modal-button-row'>
        {modalOrderDetail && (
          <Col xs={12} md={6}>
            <button
              className='button totemreports-modal-button-back button-full'
              onClick={() => hideOrderDetails()}
            >
              {translate('totem.reports.modal.button.back')}
            </button>
          </Col>
        )}
        <Col
          xs={12}
          md={6}
          className={modalOrderDetail ? '' : 'totemreports-modal-button-fechar'}
        >
          <button
            className='button button-primary button-full'
            onClick={() => closeModalDetails()}
          >
            {translate('totem.reports.modal.button.close')}
          </button>
        </Col>
      </Row>
    )
  }

  render() {
    const { closeModalDetails, modalOrderDetail } = this.props
    const { size } = this.state

    return (
      <Modal closeModal={closeModalDetails} size={size}>
        <section>
          {modalOrderDetail ? this.renderSalesOrderDetails() : null}
          {!modalOrderDetail ? this.renderModalHeader() : null}
          {!modalOrderDetail && this.showCards()
            ? this.renderModalCards()
            : null}
          {!modalOrderDetail ? this.renderModalTable() : null}
          {this.renderModalButtons()}
        </section>
      </Modal>
    )
  }
}

export default ModalReportDetails
